<template>
  <div class="lg:ml-4 flex relative md:w-full">
    <i
      :class="['fas', filled ? 'fa-times' : 'fa-search', 'text-h4 absolute self-center left-0 ml-2']"
      @click="content = ''"
    ></i>
    <input
      type="text"
      v-model="content"
      :placeholder="placeholder"
      class="flex-1 min-w-0 bg-transparent border-t border-b border-absolute-white text-absolute-white h-12 pl-10 pr-3 outline-none"
    >
  </div>
</template>

<script>
import { debounce, size } from 'lodash';

export default {
  props: {
    placeholder: String,
    value: String,
    debounced: {
      default: true,
      type: Boolean,
    },
    clearOnEmpty: {
      default: true,
      type: Boolean,
    },
    className: {
      type: String,
      default: '',
    },
  },

  watch: {
    content() {
      this.debounced ? this.debouncedApply() : this.apply();
    },
  },

  data() {
    return {
      content: this.value,
    };
  },

  computed: {
    filled() {
      return size(this.content) !== 0;
    },
  },

  methods: {
    apply() {
      if (this.content.length === 0 && this.clearOnEmpty) {
        return this.$emit('clear');
      }

      this.$emit('input', this.content);
    },

    debouncedApply: debounce(function() {
      this.apply();
    }, 1000),

    clear() {
      this.content = '';
    },
  },
};
</script>
